import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { ContentModule } from 'app/layout/components/content/content.module';
import { FooterModule } from 'app/layout/components/footer/footer.module';
import { GlobalSettingsPanelModule } from 'app/layout/components/global-settings-panel/global-settings-panel.module';
import { InsightsPanelModule } from 'app/layout/components/insights-panel/insights-panel.module';
import { InsightsSuggestionsPanelModule } from 'app/layout/components/insights-suggestions-panel/insights-suggestions-panel.module';
import { NavbarModule } from 'app/layout/components/navbar/navbar.module';
import { NotificationsModule } from 'app/layout/components/notifications-panel/notifications-panel.module';
import { QuickPanelModule } from 'app/layout/components/quick-panel/quick-panel.module';
import { ToolbarModule } from 'app/layout/components/toolbar/toolbar.module';

// Import AI Chat feature module for lateral panel usage
import { AiChatFeatureModule } from 'app/features/ai-chat';

import { VerticalLayout1Component } from 'app/layout/vertical/layout-1/layout-1.component';

@NgModule({
  declarations: [VerticalLayout1Component],
  imports: [
    RouterModule,

    FuseSharedModule,
    FuseSidebarModule,

    ContentModule,
    FooterModule,
    NavbarModule,
    QuickPanelModule,
    GlobalSettingsPanelModule,
    NotificationsModule,
    ToolbarModule,
    InsightsPanelModule,
    InsightsSuggestionsPanelModule,
    AiChatFeatureModule, // For lateral panel usage
  ],
  exports: [VerticalLayout1Component],
})
export class VerticalLayout1Module {}
